export default __webpack_public_path__ + "static/media/_competenze_pos_spessa.2a6a113a.svg";